import get from './methodGet';

export default { ...get };
